import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { MetadataSchemaField } from '@/types/metadata.types';
import { useResolvedFieldOptions } from '../useResolvedFieldOptions';

interface SelectFieldProps {
  field: MetadataSchemaField;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
}

export default function SelectField({
  field,
  value,
  onChange,
  error,
  disabled,
}: SelectFieldProps) {
  // Resolves MANUAL options or a catalog-backed data source transparently.
  const { options, isLoading } = useResolvedFieldOptions(field);

  return (
    <Select
      value={(value as string) || ''}
      onValueChange={(val) => onChange(val || null)}
      disabled={disabled || isLoading}
    >
      <SelectTrigger
        id={field.fieldKey}
        className={error ? 'border-destructive' : ''}
      >
        <SelectValue placeholder={isLoading ? 'Loading…' : field.placeholder || 'Select...'} />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
